<template>
    <div class="row">
        <div class="col-12">
            <block-header
                :title="title"
                :subtitle="subtitle"
                :description="description"
            />
        </div>
        <div class="col-12">
            <b-card class="bordered-light" v-if="userPrompts.length > 1">
                <div v-for="(prompt,index) in userPrompts" :key="index" class="px-2 prompt-group">
                    <prompt-container
                        :block-id="id"
                        :block-type="blockType"
                        :prompt="prompt"
                        :type="prompt.type"
                        :prompt-id="String(prompt.id)"
                        :page-id="pageId"
                        :key="prompt.id"
                        :is-in-modal="isInModal"
                        @updatePrompt="(data) => updatePrompt(data,index)"
                    />
                    <hr class="mt-4 mb-2" />
                </div>
            </b-card>
            <div v-else class="border-light rounded-big pt-4 px-4 pb-2 position-relative">
                <div v-for="(prompt,index) in userPrompts" :key="index">
                    <prompt-container
                        :block-id="id"
                        :block-type="blockType"
                        :prompt="prompt"
                        :type="prompt.type"
                        :prompt-id="String(prompt.id)"
                        :page-id="pageId"
                        :key="prompt.id"
                        :is-in-modal="isInModal"
                        @updatePrompt="(data) => updatePrompt(data,index)"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PromptContainer from "./PromptContainer";
import BlockHeader from "../../molecules/BlockHeader"

export default {
    name: "PromptGroup",
    components:{
        PromptContainer,
        BlockHeader
    },
    props:{
        id: Number,
        blockType: String,
        header: Object,
        prompts: Array,
        pageId: String,
        title: String,
        subtitle: String,
        description: String,
        isInModal: Boolean
    },
    data(){
        return {
            userPrompts: this.prompts
        }
    },
    methods:{
        updatePrompt(data, index){
            this.userPrompts[index].submission = data;
        }
    },
    computed:{
        groupLength(){
            return this.userPrompts.length;
        }
    }
}
</script>

<style lang="scss" scoped>
    .prompt-group:last-child {
        hr {
            display: none;
        }
    }
</style>